/* eslint-disable */

angular.module('common_app').config([
  '$httpProvider',
  function ($httpProvider) {
    const authToken = $('meta[name="csrf-token"]').attr('content');
    return ($httpProvider.defaults.headers.common['X-CSRF-TOKEN'] = authToken);
  },
]);
